module.exports = __webpack_public_path__ + "static/media/xiaoyu-icon.a251c4cd.png";